import { mediaData } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            最新上架
          </h2>
          <p className="text-foreground-500 text-sm mt-2">刚刚更新的热门内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-foreground-950/75 text-background-50 rounded text-[10px] font-medium backdrop-blur-sm">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <div className="text-xs text-accent-500 font-medium mb-1">{item.category}</div>
                <h3 className="text-xs md:text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}